import api from "./api";

export default {
  getAll: () => api.get("/colaboradores"),
  create: (data) => api.post("/colaboradores", { colaborador: data }),
  update: (id, data) => api.put(`/colaboradores/${id}`, { colaborador: data }),
  destroy: (id) => api.delete(`/colaboradores/${id}`),
};
